// extracted by mini-css-extract-plugin
export default {"body":"body-yRiso","emptyBody":"emptyBody-m8ObI","emptyBodyContent":"emptyBodyContent-quTRu","formGroup":"formGroup-pdARv"};